import { render, staticRenderFns } from "./MusterilerDetayButon.vue?vue&type=template&id=1770d42c&"
import script from "./MusterilerDetayButon.vue?vue&type=script&lang=js&"
export * from "./MusterilerDetayButon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports